import React, { useState, useEffect } from "react";
import axios from "axios";
import parse from 'html-react-parser';

import { Sectors as sectorsData } from "../../constants/Sectors"; 


const Sectors = () => {
  const [posts, setPosts] = useState([]);
  const imageLink = `./uploads/images`;

  // Function to fetch posts by category
 

  useEffect(() => {
    setPosts(sectorsData)
  }, []);

  return (
    <div className="container serviceslist">
      <div className="section-title">
        {/* <h2>Sectors Details</h2> */}
        <p>Explore our sectors in detail.</p>
      </div>

      {posts.map((post, index) => (
        <div className={`row service-item ${index % 2 === 0 ? "even" : "odd"}`} key={index}>
          <div
            className={`col-md-6 service-item-image ${
              index % 2 === 0 ? "left" : "right"
            }`}
          >
            <figure>
              <img src={`${imageLink}/${post.url}`} alt={post.title} />
              <figcaption>{post.title}</figcaption>
            </figure>
          </div>

          <div
            className={`col-md-6 service-item-text ${
              index % 2 === 0 ? "right" : "left"
            }`}
          >
            {parse(post.text)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sectors;
